import {Component, Inject, Optional} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ValidationService} from '../../services/validation/validation.service';
import {TextInputType} from '../forms/text-input/text-input.component';

@Component({
  selector: 'app-configure-email',
  templateUrl: './configure-email-dialog.component.html',
  styleUrls: ['./configure-email-dialog.component.scss']
})
export class ConfigureEmailDialogComponent {
  title = '';
  description = '';
  email = '';
  buttonOk = '';

  constructor(public dialogRef: MatDialogRef<ConfigureEmailDialogComponent>,
              @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    this.dialogRef.addPanelClass('xs-popup-confirm');
    this.title = data && data.title;
    this.description = data && data.description;
    this.email = data && data.email;
    this.buttonOk = data && data.buttonOk;
  }

  saveEmail() {
    this.dialogRef.close({
      email: this.email ? this.email : null
    });
  }

  clearEmail(): void {
    this.email = '';
  }

  isValidEmail(): boolean {
    return this.email ? ValidationService.validateEmail(this.email) : false;
  }

  protected readonly TextInputType = TextInputType;
}
